__webpack_require__.p = "/b2c/cqt-app/";